<template>
  <div v-if="display" id="signInModal" class="modal"
    aria-hidden="true"
    aria-labelledby="signInModalToggle"
    tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button"
            class="btn-close"
            @click="close"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="modal-body">
          <div class="col-md-12">
            <div class="text-center">
              <img :src="partner.logo_url" class="login-logo"/>
              <p class="auth-title">
                {{$t("auth.signIn.title")}}
              </p>
              <div class="row">
                <div class="col-md-12">
                  <InputForm v-model="params.email"
                    :placeholder="$t('auth.email')"
                    v-validate="'required|email'"
                    name="email" />
                </div>
                <div class="col-md-12">
                  <InputForm v-model="params.password"
                    :kind="'password'"
                    :placeholder="$t('auth.password')"
                    v-validate="'required'"
                    name="password" />
                </div>
                <div class="col-md-12">
                  {{$t("auth.signIn.description")}}
                </div>
                <div class="col-md-12">
                  <p class="auth-link mt-10">
                    <a href="/auth/users/password/new">
                      {{$t("auth.forgot.title")}}
                    </a>
                  </p>
                  <div class="form-group text-center" v-if="asdOauth">
                    <p>{{$t("auth.oAuth")}}</p>
                    <a href="/asdeporte/oauth">
                      <img src="../../images/asd.png" class="asd-logo"/>
                    </a>
                  </div>
                  <div class="form-group">
                    <button type="submit" class="auth-button" @click="create">
                      {{$t("auth.signIn.create")}}
                    </button>
                  </div>
                  <p class="auth-link mt-10" v-if="partner.register_user">
                    {{$t("auth.signIn.hasAccount")}}
                    <router-link :to="{name: 'SignUp'}" class="auth-link">
                      {{$t("auth.signUp.title")}}
                    </router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputForm from "../../components/InputForm"
import User from "../../models/User"
import Partner from "../../models/Partner"

export default {
  name: "Auth.SignIn",
  components: {
    InputForm
  },
  data() {
    return {
      display: false,
      loading: true,
      email: "",
      params: {
        email: "",
        password: ""
      }
    }
  },
  created() {
    this.$root.$on('openSignIn', this.open)
    this.$root.$on('setPartner', this.setPartner)
  },
  methods: {
    open() {
      this.display = true
    },
    close() {
      this.display = false
    },
    setPartner(partner) {
      this.partner = partner
    },
    async create() {
      let valid = await this.isValid;
      if(valid) {
        this.$root.$emit("showLoader")
        let user = new User()
        user.signIn(this.params).then((response) => {
          setTimeout(function() { location.reload(); }, 1500);
        }).catch((e) => {
          this.$root.$emit("hideLoader")
          this.$alertify.error(e.response.response.data.errors)
        })
      }
    }
  },
  computed: {
    async isValid() {
      return await this.$validator.validate().then(valid => {
        return valid
      })
    },
    asdOauth() {
      const host = window.location.hostname
      return host.includes("2digital.") || host.includes("2digitalstage.")
    }
  }
}
</script>

<style lang="scss">
  @import "../../scss/variables";

  #signInModal {
    .modal-content {
      border-radius: 20px;
    }
  }

  .auth-title {
    font-family: $font-bold;
    font-style: normal;
    font-weight: 800;
    font-size: 32px;
    line-height: 39px;
    text-align: center;
    margin-top: 10px;
    color: $secondary-base !important;
  }

  .auth-link {
    color: grey !important;
    a {
      color: grey !important;
      cursor: pointer;
      text-decoration: underline !important;
    }
  }

  .auth-button {
    padding: 10px 5px 10px 5px;
    background: $secondary-base !important;
    border: 1px solid $secondary-base !important;
    color: white;
    margin-top: 30px;
    margin-bottom: 20px;
    border-radius: 25px;
    width: 100%;
    font-family: $font-bold;
  }

  .auth-legend {
    font-style: italic;
    font-size: 13px;
  }

  .asd-logo {
    max-height: 52px;
  }

  .login-logo {
    max-height: 52px;
  }
</style>
